module.exports = __webpack_public_path__ + "img/maas_wrapbg2.ae58e8a0.png";